import { useEffect, useId } from "react"
import { create as createStore } from "zustand"

function getScrollbarWidth() {
  const outer = document.createElement("div")
  outer.style.visibility = "hidden"
  outer.style.overflow = "scroll"
  outer.style.width = "100px"
  document.body.appendChild(outer)

  const inner = document.createElement("div")
  outer.appendChild(inner)

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
  document.body.removeChild(outer)
  return scrollbarWidth
}

type State = Record<string, boolean>

const defaultState: State = {}

const store = createStore(() => defaultState)

function disableScroll() {
  if (!document.body.classList.contains("no-scroll")) {
    document.body.classList.add("no-scroll")
    document.body.style.setProperty("--scrollbar-width", `${getScrollbarWidth()}px`)
    console.debug("🔒 body scroll lock enabled")
  }
}

function enableScroll() {
  if (document.body.classList.contains("no-scroll")) {
    document.body.classList.remove("no-scroll")
    console.debug("🔒 body scroll lock disabled")
  }
}

store.subscribe((state) => {
  const openModalCount = Object.values(state).filter(Boolean).length

  if (openModalCount > 0) {
    disableScroll()
  } else {
    enableScroll()
  }
})

function setModalOpen(id: string, open: boolean) {
  if (!!store.getState()[id] !== open) {
    const changes = { [id]: open }
    console.debug("📃 modal state changed", changes)
    store.setState(changes)
  }
}

export function useOpenModalCount() {
  return store((state) => Object.values(state).filter(Boolean).length)
}

export function usePreventBodyScroll(prevent: boolean | undefined) {
  const id = useId()

  useEffect(() => {
    setModalOpen(id, !!prevent)
    return () => {
      setModalOpen(id, false)
    }
  }, [id, prevent])
}
